import { MESSAGE_ALL_TYPE } from '../constants';
import {
  IJarvisCardInfo,
  IMessageContent,
  ROBOT_SENDER,
} from '../lib/sendMessage';
import createRequest from '../utils/createRequest';

export type FetchType = ReturnType<typeof createRequest>;
export interface IKeepGuideParams {
  businessLineId: string;
  dialogId: number;
}

export const getBaseConfig = (request: FetchType) => (apiOrigin?: string) =>
  request(`/im-session/user/config`, {
    method: 'POST',
    data: {
      tags: ['imCloudConfig', 'user'],
    },
  });

// 获取token
export const getTokenApi = (request: FetchType) => (apiOrigin?: string) =>
  request(`${apiOrigin || ''}/api/im-session/im-c/user/token/client`, {
    method: 'POST',
    data: {},
  });

export const createDialog = (request: FetchType) => (data: object) =>
  request(`/im-robot/robot/dialog/v2`, {
    method: 'POST',
    data,
  });

// Like or tap
export const postThumbAction = (request: FetchType) => (data: object) =>
  request(`/im-robot/robot/faq/action`, {
    method: 'POST',
    data,
  });

// Continue to consult
export const keepGuide = (request: FetchType) => (data: object) =>
  request(`/im-robot/robot/guide-card`, {
    method: 'POST',
    data,
  });

// Transfer to labor
export const transferPeopleApi = (request: FetchType) => (data: object) =>
  request(`/im-session/dialog/transfer`, {
    method: 'POST',
    data,
  });

// Transfer manual WithDmc
export const transferPeopleDmcApi = (request: FetchType) => (data: object) =>
  request(`/im-robot/robot/dialog/transfer`, {
    method: 'POST',
    data,
  });

// Queuing for polling
export const getDialogQueue = (request: FetchType) => (data: object) =>
  request(`/im-session/dialog/queue`, {
    method: 'POST',
    data,
    notCheckService: true,
  });

// Cancel the queued waiting session
export const cancelDialogQueue = (request: FetchType) => (data: object) =>
  request(`/im-session/dialog/queue`, {
    method: 'PUT',
    data,
  });

// Conversational heartbeat
export const setClientHeartbeat = (request: FetchType) => (data: object) =>
  request('/im-session/user/clientHeartbeat', {
    method: 'PUT',
    data,
    isTrain: true,
    notCheckService: true,
  });

//  End session
export const deleteDialog = (request: FetchType) => (data: object) =>
  request('/im-session/dialog', {
    method: 'DELETE',
    data: {
      ...data, //dialogId
      endType: 4, // 代表用户侧结束会话
    },
  });

/**
 * @desc Send bot message
 * @param dialogScene required 1 group chat 2 individual chat
 * @param message  {content, extMap}
 * @param msgType 10001
 * @param sender 1000001 bot
 * @returns Promise < void >
 */
export const sendRobotMessage =
  (request: FetchType) => (params: IMessageContent & { dialogId: string }) => {
    return request('/im-session/message/imc-message', {
      method: 'POST',
      data: {
        dialogId: params.dialogId,
        dialogScene: 1,
        message: {
          content: params.content,
          extMap: { ...params.ext },
          msgType: params.type || MESSAGE_ALL_TYPE.MESSAGE_TYPE_TEXT,
          sender: ROBOT_SENDER,
        },
      },
    });
  };

/**
 * @desc Modify message
 * @param dialogId Session ID
 * @param serverId Message ID
 * @param extMap Extended field
 * @returns Promise < void >
 */
export const modifyMessage = (request: FetchType) => (data: object) =>
  request('/im-session/message/modify', {
    method: 'POST',
    data,
  });

/**
 * @desc Send Javis card
 * @param dialogId Session ID
 * @param dialogScene 1
 * @param jarvisEventInfo
 *  {"appCode": "string",
 *    "data": "string",
 *    "dataFromCache": true,
 *    "eventCode": "string",
 *    "triggerType": "string"}
 * @sender
 * @returns Promise < void >
 */
export const sendJarvisCard =
  (request: FetchType) =>
  ({ dialogId, ...params }: IJarvisCardInfo & { dialogId: string }) =>
    request('/im-session/message/jarvisEvent', {
      method: 'POST',
      data: {
        dialogId: dialogId,
        dialogScene: 1,
        jarvisEventInfo: params,
        sender: ROBOT_SENDER,
      },
    });
export const triggerJarvisEvent = (request: FetchType) => (data: object) =>
  request(`/im-session/message/jarvisEvent`, {
    method: 'POST',
    data,
  });

// Get im configuration
export const getImConfig = (request: FetchType) => (bid: string) =>
  request(`/im-business/configure/business-config/${bid}`, {
    method: 'GET',
  });

// Dou + Order
export const douPlusOrderList = (request: FetchType) => (data: object) =>
  request('/im-session/dou-order/paid-order-list', {
    method: 'POST',
    data: data,
  });

// Click and step on the manual statistical interface rd Haitao
export const faqTransfer = (request: FetchType) => (data: object) =>
  request('/im-robot/robot/faq/transfer', {
    method: 'POST',
    data,
  });

export const getJarvisComponentList =
  (request: FetchType) =>
  ({ dialogId, eventCode }: { dialogId: string; eventCode: string }) =>
    request(
      `/api/im-session/jarvis/getJarvisComponentList?dialogId=${dialogId}&eventCode=${eventCode}`,
      {
        method: 'GET',
      },
    );

// Get shortcut button configuration
export const getFastButtonConfig = (request: FetchType) => (uniqueId: string) =>
  request('/im-robot/dmc-config/fast-button-config', {
    method: 'GET',
    params: {
      uniqueId,
    },
  });

// 通过lark机器人发送未读提醒
export const postFeishuUnread = (request: FetchType) => (dialogId: string) =>
  request('/im-session/dialog/unread', {
    method: 'GET',
    params: {
      dialogId,
    },
  });

// 获取是否能够展示机器人满意度评价按钮
export const canDisplayRobotButton =
  (request: FetchType) =>
  (dialogId: string | number, robotSatisfactionConfigId: string | number) =>
    request('/im-session/satisfaction/canDisplayRobotButton', {
      method: 'GET',
      params: {
        dialogId,
        robotSatisfactionConfigId,
      },
    });
